import { TablePagination } from '@mui/material';
import { CSSProperties } from 'react';

import { styled } from '../../styles';

import { TablePaginationProps } from './types';

export const StyledTablePagination = styled(
  TablePagination,
)<TablePaginationProps>(({ theme }) => ({
  '&.MuiTablePagination-root': {
    width: '100%',
    minHeight: theme.spacing(11),
    marginTop: theme.spacing(6),

    '.MuiTablePagination-input': {
      marginRight: theme.spacing(4),
    },

    '.MuiTablePagination-actions': {
      marginLeft: theme.spacing(2),
    },

    '.MuiTablePagination-selectLabel': {
      margin: 0,
      ...(theme.typography.body5 as CSSProperties),
      color: theme.palette.text3,
    },
    '.MuiTablePagination-displayedRows': {
      margin: 0,
      ...(theme.typography.body5 as CSSProperties),
      color: theme.palette.text3,
    },
    '.MuiTablePagination-select': {
      ...(theme.typography.body5 as CSSProperties),
      color: theme.palette.text1,
      padding: theme.spacing(0),
      paddingRight: theme.spacing(4),
    },
    '.MuiTablePagination-selectIcon': {
      width: theme.spacing(4),
      height: theme.spacing(4),
      marginTop: theme.spacing(0.9),
      color: theme.palette.text3,
    },
    '.MuiIconButton-root': {
      padding: theme.spacing(2),
      margin: theme.spacing(0),
    },
  },
}));
